var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPesquisarBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pesquisar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3B-Liner_Desktop_Home_Escuro",
    transform: "translate(-1224.000000, -685.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "mn-copy-3",
    transform: "translate(645.000000, 633.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(566.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.828449,42.7235296 C21.2012491,42.7235296 15.0181818,36.5214761 15.0181818,28.8708557 C15.0181818,21.2202353 21.2012491,15.0181818 28.828449,15.0181818 C36.4556489,15.0181818 42.6387162,21.2202353 42.6387162,28.8708557 C42.6387162,36.5214761 36.4556489,42.7235296 28.828449,42.7235296 Z M43.9818182,43.9818182 L39.8194729,39.8954537",
    id: "pesquisar",
    transform: "translate(29.500000, 29.500000) scale(-1, 1) translate(-29.500000, -29.500000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesquisarBig);
export default __webpack_public_path__ + "static/media/pesquisar_big.19f55a39d7402f5d6cc571a23d1dd06d.svg";
export { ForwardRef as ReactComponent };